import { render, staticRenderFns } from "./ModalEditDefaultOpeningHours.vue?vue&type=template&id=6ad7f51c"
import script from "./ModalEditDefaultOpeningHours.vue?vue&type=script&lang=js"
export * from "./ModalEditDefaultOpeningHours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports